import type { AccountInfo } from '@azure/msal-browser';

/**
 * Whether the signed-in account is a member of the admin security group.
 *
 * Entra surfaces group membership in the `groups` claim of the ID token (the app
 * registration must emit group claims). We read it from the account's
 * `idTokenClaims`. Pure + token-shape-only so it is unit-testable without MSAL.
 *
 * Note: when a user is in more than ~200 groups Entra emits a `_claim_names`
 * overage instead of `groups` and membership must be checked via Microsoft Graph.
 * That path is out of scope for the walking skeleton — flagged in the PR.
 */
export function isAdmin(account: Pick<AccountInfo, 'idTokenClaims'> | null, adminGroupId: string): boolean {
    if (!account?.idTokenClaims) return false;
    const claims = account.idTokenClaims as { groups?: unknown };
    const groups = claims.groups;
    if (!Array.isArray(groups)) return false;
    return groups.some((g) => typeof g === 'string' && g === adminGroupId);
}
